import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DataUtils } from 'ng-jhipster';

import { MarketdateExpense } from './marketdate-expense.model';
import { MarketdateExpenseService } from './marketdate-expense.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-marketdate-expense',
    templateUrl: './marketdate-expense.component.html'
})
export class MarketdateExpenseComponent implements OnInit, OnDestroy {
marketdateExpenses: MarketdateExpense[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateExpenseService: MarketdateExpenseService,
        private alertService: AlertService,
        private dataUtils: DataUtils,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.marketdateExpenseService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.marketdateExpenses = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.marketdateExpenseService.query().subscribe(
            (res: Response) => {
                this.marketdateExpenses = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInMarketdateExpenses();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: MarketdateExpense) {
        return item.id;
    }

    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }
    registerChangeInMarketdateExpenses() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateExpenseListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense.component.ts